var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150.3 141.7",
    style: {
      enableBackground: "new 0 0 150.3 141.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1753FF;stroke:#1753FF;stroke-width:5;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.7,132.4c0.3-0.5,0.6-1,0.9-1.4c4.3-7,8.6-14,12.9-21c0.3-0.4,0.4-0.9,0.7-1.3c0.7-1.4,0.3-2.6-0.5-3.9 c-2.2-3.7-4-7.6-5.3-11.7c-0.9-2.9-1.8-5.9-2.4-8.9c-0.7-3.3-1-6.7-1-10.1c-0.1-4,0.1-7.9,0.8-11.9c0.7-4.4,1.8-8.6,3.4-12.8 c1.5-4.1,3.5-8,5.8-11.7c4.9-7.9,11.3-14.4,19.1-19.6c5.9-3.9,12.3-6.8,19.2-8.7c3.8-1,7.6-1.7,11.5-2c4.4-0.3,8.8-0.3,13.1,0.2 c4.2,0.5,8.3,1.4,12.3,2.8c3.1,1.1,6.1,2.4,9.1,3.8c4.3,2,8.2,4.6,11.9,7.5c4.8,3.8,9.1,8.3,12.7,13.3c3.7,5.1,6.5,10.6,8.5,16.6 c2.2,6.7,3.3,13.5,3,20.5c-0.1,1.9-0.5,3.9-0.6,5.8c-0.2,3.5-0.8,6.9-1.7,10.3c-2.2,8-6,15.2-11.3,21.6 c-4.8,5.6-10.4,10.2-16.9,13.7c-6.4,3.5-13.1,6.2-20.2,7.7c-3.1,0.7-6.3,1-9.5,1c-13.9,0.2-27.7,0.6-41.6,0.4 c-10.8-0.1-21.5-0.2-32.3-0.2C8.6,132.5,8.2,132.5,7.7,132.4z M22.2,124.5c0.3,0,0.5,0,0.7,0c7.3,0,14.6,0.1,21.9,0.1 c13.1-0.1,26.3-0.3,39.4-0.5c2.1,0,4.1-0.2,6.1-0.7c7.6-1.6,14.8-4.4,21.4-8.6c6-3.8,11.1-8.6,15.1-14.5c3.2-4.7,5.5-9.9,6.7-15.4 c0.7-3.1,1.1-6.4,1.3-9.6c0.3-4,0.4-8-0.2-12.1c-0.7-4.9-2-9.5-4-14c-3.1-6.9-7.4-12.8-12.9-18c-5-4.7-10.5-8.5-16.8-11.1 c-3.6-1.6-7.3-2.9-11.2-3.5c-1-0.2-1.9-0.6-2.9-0.7c-2.5-0.3-5-0.6-7.5-0.6c-6.5-0.2-12.9,0.7-19.1,2.8 c-8.2,2.7-15.5,7.1-21.8,13.1c-6.9,6.6-11.8,14.5-14.7,23.6C21.8,60.5,21,66.4,21,72.5c0,6.6,1.1,13,3.4,19.3 c1.4,4,3.3,7.8,5.6,11.4c0.7,1.1,0.9,2.1,0.8,3.3c-0.3,2.7-0.9,5.2-2.3,7.6c-1.7,2.9-3.5,5.8-5.3,8.8 C22.9,123.3,22.5,123.8,22.2,124.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.9,70c0-4.2,3.4-7.7,7.5-7.8c4.4,0,8,3.3,8,7.6s-3.4,7.8-7.6,7.9C101.4,77.7,97.9,74.3,97.9,70z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.8,70.1c0.1,4.4-3.8,7.8-7.9,7.6c-4.4-0.2-7.6-3.8-7.5-7.9c0.2-4.9,4.3-7.7,8.2-7.5 C82.6,62.5,85.9,66,85.8,70.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.9,70c-0.1-4,3.4-7.6,7.5-7.7c4.1-0.1,7.8,3.3,7.9,7.3c0.1,4.3-3.2,7.9-7.5,8.1C46.5,77.8,43,74.4,42.9,70z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.9ed0f2d6d181b2d8e1ebfcd1862edcf1.svg";
export { ForwardRef as ReactComponent };